import { ideaConstants } from '../_constants';

//-- get the list of banners
export function getIdeasList(state = {}, action) {
  switch (action.type) {
    case ideaConstants.IDEA_LIST_REQUEST:
      return {
        getIdeasList: false
      };

    case ideaConstants.IDEA_LIST_SUCCESS:
      //console.log("REDUCER ", action);
      return { isGetAdvertismentList: true, getIdeasList: action.successAction };

    case ideaConstants.IDEA_LIST_ERROR:
      return {
        getIdeasList: false,
      };

    case ideaConstants.IDEA_SEARCH_REQUEST:
      return { isGetAdvertismentList: true, getIdeasList: action.successAction.data };

    default:
      return state
  }
}

export function saveIdea(state = {}, action) {
  switch (action.type) {
    case ideaConstants.IDEA_ADDED_REQUEST:
      return {
        savedIdea: false
      };

    case ideaConstants.IDEA_ADDED_SUCCESS:
      //console.log("REDUCER ", action);
      return { savedIdea: action.successAction };

    case ideaConstants.IDEA_ADDED_FAILURE:
      return {
        savedIdea: false,
      };

    default:
      return state
  }
}



export function deleteIdea(state = {}, action) {
  switch (action.type) {
    case ideaConstants.IDEA_DELETE_REQUEST:
      return {
        deleteIdea: false
      };

    case ideaConstants.IDEA_DELETE_SUCCESS:
      //console.log("REDUCER ", action);
      return { deleteIdea: action.successAction };

    case ideaConstants.IDEA_DELETE_FAILURE:
      return {
        deleteIdea: false,
      };

    default:
      return state
  }
}


